import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { purple, deepOrange } from '@material-ui/core/colors';
import { useSelector } from 'react-redux';
import { isMobile } from 'app-constants';

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: deepOrange[700],
    '&:hover': {
      backgroundColor: deepOrange[900]
    },
    width: '100%',
    minWidth: (props) => (!props.islistview && isMobile ? null : 200)
  }
}))(Button);

function CustomButton({ isDisabled, title, handleClick }) {
  const isListView = useSelector((state) => state.userPrefference.isListView);
  return (
    <div>
      <ColorButton
        variant="contained"
        color="primary"
        disabled={isDisabled}
        onClick={handleClick}
        islistview={isListView && isListView.toString()}>
        {title}
      </ColorButton>
    </div>
  );
}

export default CustomButton;
